import React from 'react'
import primodal from './Primodal.module.css'

/* eslint-disable @next/next/no-img-element */

function PremiumModal({ onclick }: { onclick?: () => void }) {
  return (
    <div className={primodal.overlay}>
      <div className={primodal.modal}>
        <button className={primodal.closeBtn} onClick={onclick}>
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13" fill="none"><path d="M12.8015 0.744073C12.4427 0.385334 11.8632 0.385334 11.5045 0.744073L7.00645 5.23291L2.50842 0.734874C2.14968 0.376136 1.57018 0.376136 1.21144 0.734874C0.852698 1.09361 0.852698 1.67311 1.21144 2.03185L5.70947 6.52988L1.21144 11.0279C0.852698 11.3867 0.852698 11.9662 1.21144 12.3249C1.57018 12.6836 2.14968 12.6836 2.50842 12.3249L7.00645 7.82686L11.5045 12.3249C11.8632 12.6836 12.4427 12.6836 12.8015 12.3249C13.1602 11.9662 13.1602 11.3867 12.8015 11.0279L8.30342 6.52988L12.8015 2.03185C13.151 1.68231 13.151 1.09361 12.8015 0.744073Z" fill="#A2A2A2"></path></svg>
        </button>
        <div className={primodal.modalContent}>
          <div className={primodal.modalContentleft}>
            <h3>
              To subscribe and enjoy all dramas without interruption, download the DramaFlicks app.
            </h3>
          </div>

          <div className={primodal.modalContentright}>
            <img
              src="../premiumAppScanner.webp"
              alt="premiumAppScanner"
              className={primodal.image}
            />
          </div>

              <div className={primodal.getApp}>
                 <a href={`https://dramaflicksapp.com/getapp.php`} className={primodal.commonBtnGetapp}>
                        Download App
                  </a>
              </div>



        </div>
      </div>
    </div>
  )
}

export default PremiumModal